import { useState } from "react";
import { IconButton, Popover, Typography, Box } from "@mui/material";
// import FunctionsIcon from '@mui/icons-material/Functions';
import CalculateIcon from "@mui/icons-material/Calculate";
import { subtract } from "lodash";

const DispatchWeightFormula = ({ gross, tare, total_bag_weight, unit }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;


  return (
    <>
    <div className="d-flex" style={{whiteSpace: "nowrap"}}> {Math.abs(Number(subtract(subtract(gross, tare).toFixed(3), total_bag_weight) || 0).toFixed(3))} {unit}  <IconButton
        size="small"
        onClick={handleOpen}
        sx={{ padding: "0 0 0 4px" }}
      >
        <CalculateIcon fontSize="inherit" />
      </IconButton></div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" style={{ fontFamily: 'Poppins'}}>
            <strong>Dispatch Weight Formula:</strong>
            <br />
            <br />
            = Gross Weight - Tare Weight - Total Bag Weights
            <br /> = {gross} {unit} - {tare} {unit} - {total_bag_weight} {unit}
            <br />
            <strong> </strong> ={" "}
            {Math.abs(Number(subtract(subtract(gross, tare).toFixed(3), total_bag_weight) || 0).toFixed(3))} {unit}
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default DispatchWeightFormula;

// import { useState } from "react";
// import { IconButton, Popover, Typography, Box } from "@mui/material";
// // import FunctionsIcon from '@mui/icons-material/Functions';
// import CalculateIcon from "@mui/icons-material/Calculate";
// import { subtract } from "lodash";

// const DispatchWeightFormula = ({ isContractTypeFOR, dispatchWeightbridge, gross, tare, total_bag_weight, unit }) => {
//   console.log(isContractTypeFOR, "isContractTypeFOR");
//   const [anchorEl, setAnchorEl] = useState(null);

//   const handleOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const open = Boolean(anchorEl);
//   const id = open ? "formula-popover" : undefined;


//   return (
//     <>
//     <div className="d-flex"> {subtract((isContractTypeFOR
//     ? Number(dispatchWeightbridge ?? 0).toFixed(3)
//     : subtract(gross, tare).toFixed(3)),
//      total_bag_weight)} {unit}  <IconButton
//         size="small"
//         onClick={handleOpen}
//         sx={{ padding: "0 0 0 4px" }}
//       >
//         <CalculateIcon fontSize="inherit" />
//       </IconButton></div>
//       <Popover
//         id={id}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "left",
//         }}
//       >
//         <Box sx={{ p: 2 }}>
//           <Typography variant="body2" style={{ fontFamily: 'Poppins'}}>
//             <strong>Dispatch Weight Formula:</strong>
//             <br />
//             <br />
//             {isContractTypeFOR ? "= Dispatch WeightBridge - Total Bag Weights"
//             : `= Gross Weight - Tare Weight - Total Bag Weights`
//             }
//             <br /> = {isContractTypeFOR ? `${dispatchWeightbridge}` : `${gross} ${unit} - ${tare} ${unit}`} - {total_bag_weight} {unit}
//             <br />
//             <strong> </strong> ={" "}
//             {subtract(isContractTypeFOR
//             ? Number(dispatchWeightbridge ?? 0).toFixed(3) : subtract(gross, tare).toFixed(3), total_bag_weight)} {unit}
//           </Typography>
//         </Box>
//       </Popover>
//     </>
//   );
// };

// export default DispatchWeightFormula;

